import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-43f28d2f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "musicDetails"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "middle"
};
const _hoisted_6 = {
  class: "cp"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "footer"
};
const _hoisted_9 = {
  class: "footertop"
};
const _hoisted_10 = {
  class: "footermiddle"
};
const _hoisted_11 = {
  class: "footerbottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee");

  const _component_van_progress = _resolveComponent("van-progress");

  const _component_SongComment = _resolveComponent("SongComment");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "bgimg",
    src: $props.musicList.al.picUrl,
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "25px",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.updateIsPopups(false)),
    color: "#fff"
  }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_Vue3Marquee, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.musicList.name), 1)]),
    _: 1
  }), _createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.musicList.ar, item => {
    return _openBlock(), _createElementBlock("span", {
      key: item
    }, _toDisplayString(item.name), 1);
  }), 128)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff"
  })])]), _createVNode(_component_van_icon, {
    name: "link-o",
    size: "25px",
    color: "#fff"
  })]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    class: _normalizeClass(["img_ar", {
      img_ar_pauesd: $props.isbtnShow,
      img_ar_play: !$props.isbtnShow
    }]),
    src: $props.musicList.al.picUrl,
    onClick: _cache[1] || (_cache[1] = $event => $data.lyricIsShow = true)
  }, null, 10, _hoisted_7)]), _createElementVNode("div", {
    class: _normalizeClass(["cz", {
      cz_active: !$props.isbtnShow
    }])
  }, null, 2)], 512), [[_vShow, !$data.lyricIsShow]]), _withDirectives(_createElementVNode("div", {
    class: "lyric",
    ref: "musicLyric",
    onClick: _cache[2] || (_cache[2] = $event => $data.lyricIsShow = false)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.lyric, item => {
    return _openBlock(), _createElementBlock("p", {
      key: item,
      class: _normalizeClass({
        p_active: _ctx.currentTime * 1000 >= item.time && _ctx.currentTime * 1000 < item.pretime
      })
    }, _toDisplayString(item.lrc), 3);
  }), 128))], 512), [[_vShow, $data.lyricIsShow]]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_van_icon, {
    name: "like-o",
    size: "25",
    color: "#fff"
  }), _createVNode(_component_van_icon, {
    name: "down",
    size: "25",
    color: "#fff"
  }), _createVNode(_component_van_icon, {
    name: "music-o",
    size: "25",
    color: "#fff"
  }), _createVNode(_component_van_icon, {
    name: "chat-o",
    badge: $data.songComment == null ? 0 : $data.songComment.data.total,
    size: "25",
    color: "#fff",
    onClick: _cache[3] || (_cache[3] = $event => $data.isPopups = true)
  }, null, 8, ["badge"]), _createVNode(_component_van_icon, {
    name: "exchange",
    size: "25",
    color: "#fff"
  })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_progress, {
    percentage: this.currentTime / this.duration * 100,
    "show-pivot": false
  }, null, 8, ["percentage"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_icon, {
    name: "revoke",
    size: "25",
    color: "#fff"
  }), _createVNode(_component_van_icon, {
    class: "iconfont",
    "class-prefix": "icon",
    name: "shangyishou",
    size: "30",
    color: "#fff",
    onClick: _cache[4] || (_cache[4] = $event => $options.toplay(-1))
  }), $props.isbtnShow ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    name: "play-circle-o",
    size: "45",
    onClick: $props.play,
    color: "#fff"
  }, null, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    name: "pause-circle-o",
    size: "45",
    onClick: $props.play,
    color: "#fff"
  }, null, 8, ["onClick"])), _createVNode(_component_van_icon, {
    class: "iconfont",
    "class-prefix": "icon",
    name: "xiayishou",
    size: "30",
    color: "#fff",
    onClick: _cache[5] || (_cache[5] = $event => $options.toplay(1))
  }), _createVNode(_component_van_icon, {
    name: "bars",
    size: "25",
    color: "#fff"
  })])]), _createVNode(_component_van_popup, {
    show: $data.isPopups,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.isPopups = $event),
    round: "",
    position: "bottom",
    style: {
      height: '65%',
      width: '100%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_SongComment, {
      musicList: $props.musicList,
      songComment: $data.songComment
    }, null, 8, ["musicList", "songComment"])]),
    _: 1
  }, 8, ["show"])]);
}